import { render } from "./main-filter-item.vue?vue&type=template&id=5651b8fe&ts=true"
import script from "./main-filter-item.vue?vue&type=script&lang=ts"
export * from "./main-filter-item.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__